import React, { useState } from 'react';
interface JokerCard {
  id: string;
  name: string;
  rarity: 'Common' | 'Uncommon' | 'Rare' | 'Legendary';
  effect: string;
  effectType: 'chips' | 'mult' | 'xmult' | 'special';
  emoji: string;
  description: string;
  example: string;
}
const jokers: JokerCard[] = [{
  id: 'joker',
  name: '小丑',
  rarity: 'Common',
  effect: '+4 倍率',
  effectType: 'mult',
  emoji: '🃏',
  description: '最基础的小丑牌，每次出牌都给你+4倍率。',
  example: '原本2倍率 → 变成6倍率'
}, {
  id: 'greedy',
  name: '贪婪小丑',
  rarity: 'Common',
  effect: '每张方块牌 +3 倍率',
  effectType: 'mult',
  emoji: '💰',
  description: '打出的牌中，每有一张方块♦，就获得+3倍率。',
  example: '打出3张方块 → +9倍率'
}, {
  id: 'lusty',
  name: '好色小丑',
  rarity: 'Common',
  effect: '每张红心牌 +3 倍率',
  effectType: 'mult',
  emoji: '❤️',
  description: '打出的牌中，每有一张红心♥，就获得+3倍率。',
  example: '打出2张红心 → +6倍率'
}, {
  id: 'wrathful',
  name: '愤怒小丑',
  rarity: 'Common',
  effect: '每张黑桃牌 +3 倍率',
  effectType: 'mult',
  emoji: '⚡',
  description: '打出的牌中，每有一张黑桃♠，就获得+3倍率。',
  example: '打出4张黑桃 → +12倍率'
}, {
  id: 'gluttonous',
  name: '贪吃小丑',
  rarity: 'Common',
  effect: '每张梅花牌 +3 倍率',
  effectType: 'mult',
  emoji: '🍀',
  description: '打出的牌中，每有一张梅花♣，就获得+3倍率。',
  example: '打出3张梅花 → +9倍率'
}, {
  id: 'jolly',
  name: '快乐小丑',
  rarity: 'Common',
  effect: '打出一对时 +8 倍率',
  effectType: 'mult',
  emoji: '😄',
  description: '当你打出的牌型包含一对时，获得+8倍率。',
  example: '打出一对K → 额外+8倍率'
}, {
  id: 'zany',
  name: '疯狂小丑',
  rarity: 'Common',
  effect: '打出三条时 +12 倍率',
  effectType: 'mult',
  emoji: '🤪',
  description: '当你打出的牌型包含三条时，获得+12倍率。',
  example: '打出三条A → 额外+12倍率'
}, {
  id: 'mad',
  name: '愤怒小丑',
  rarity: 'Common',
  effect: '打出两对时 +10 倍率',
  effectType: 'mult',
  emoji: '😡',
  description: '当你打出两对时，获得+10倍率。',
  example: '打出两对 → 额外+10倍率'
}, {
  id: 'crazy',
  name: '疯狂小丑',
  rarity: 'Common',
  effect: '打出顺子时 +12 倍率',
  effectType: 'mult',
  emoji: '🌀',
  description: '当你打出顺子时，获得+12倍率。',
  example: '打出顺子 → 额外+12倍率'
}, {
  id: 'droll',
  name: '滑稽小丑',
  rarity: 'Common',
  effect: '打出同花时 +10 倍率',
  effectType: 'mult',
  emoji: '🎭',
  description: '当你打出同花时，获得+10倍率。',
  example: '打出同花 → 额外+10倍率'
}, {
  id: 'sly',
  name: '狡猾小丑',
  rarity: 'Common',
  effect: '打出一对时 +50 筹码',
  effectType: 'chips',
  emoji: '🦊',
  description: '当你打出的牌型包含一对时，获得+50筹码。',
  example: '打出一对 → 额外+50筹码'
}, {
  id: 'wily',
  name: '机智小丑',
  rarity: 'Common',
  effect: '打出三条时 +100 筹码',
  effectType: 'chips',
  emoji: '🧠',
  description: '当你打出三条时，获得+100筹码。',
  example: '打出三条 → 额外+100筹码'
}, {
  id: 'clever',
  name: '聪明小丑',
  rarity: 'Common',
  effect: '打出两对时 +80 筹码',
  effectType: 'chips',
  emoji: '🎓',
  description: '当你打出两对时，获得+80筹码。',
  example: '打出两对 → 额外+80筹码'
}, {
  id: 'devious',
  name: '狡诈小丑',
  rarity: 'Common',
  effect: '打出顺子时 +100 筹码',
  effectType: 'chips',
  emoji: '🗡️',
  description: '当你打出顺子时，获得+100筹码。',
  example: '打出顺子 → 额外+100筹码'
}, {
  id: 'crafty',
  name: '工艺小丑',
  rarity: 'Common',
  effect: '打出同花时 +80 筹码',
  effectType: 'chips',
  emoji: '🔨',
  description: '当你打出同花时，获得+80筹码。',
  example: '打出同花 → 额外+80筹码'
}, {
  id: 'half',
  name: '半价小丑',
  rarity: 'Common',
  effect: '手牌≤3张时 +20 倍率',
  effectType: 'mult',
  emoji: '✂️',
  description: '当你手牌中剩余3张或更少时，获得+20倍率。高风险高回报！',
  example: '手牌剩2张 → +20倍率'
}, {
  id: 'triboulet',
  name: '特里布莱特',
  rarity: 'Legendary',
  effect: 'K和Q的筹码值×2',
  effectType: 'xmult',
  emoji: '👑',
  description: '传说级小丑！让K和Q的筹码贡献翻倍，配合高牌型极其强力。',
  example: 'K原本+10筹码 → 变成+20筹码'
}, {
  id: 'blueprint',
  name: '蓝图',
  rarity: 'Rare',
  effect: '复制右侧小丑的效果',
  effectType: 'special',
  emoji: '📋',
  description: '复制你小丑槽位中右侧那张小丑牌的全部效果，相当于拥有两张一样的小丑！',
  example: '右侧是+4倍率小丑 → 蓝图也给+4倍率'
}];
const rarityConfig = {
  Common: {
    color: '#a0a0c0',
    bg: 'rgba(100,100,120,0.2)',
    border: 'rgba(150,150,170,0.4)',
    label: '普通'
  },
  Uncommon: {
    color: '#60c060',
    bg: 'rgba(50,150,50,0.15)',
    border: 'rgba(80,200,80,0.4)',
    label: '不常见'
  },
  Rare: {
    color: '#6090ff',
    bg: 'rgba(50,80,200,0.15)',
    border: 'rgba(80,120,255,0.4)',
    label: '稀有'
  },
  Legendary: {
    color: '#FFD700',
    bg: 'rgba(200,150,0,0.15)',
    border: 'rgba(255,200,0,0.5)',
    label: '传说'
  }
};
const effectTypeConfig = {
  chips: {
    color: '#4fc3f7',
    label: '+筹码',
    bg: 'rgba(79,195,247,0.1)'
  },
  mult: {
    color: '#ff6666',
    label: '+倍率',
    bg: 'rgba(255,68,68,0.1)'
  },
  xmult: {
    color: '#ff8c00',
    label: '×倍率',
    bg: 'rgba(255,140,0,0.1)'
  },
  special: {
    color: '#b44fff',
    label: '特殊',
    bg: 'rgba(180,79,255,0.1)'
  }
};
export function JokerSection() {
  const [selectedJoker, setSelectedJoker] = useState<string | null>(null);
  const [filterType, setFilterType] = useState<'all' | 'chips' | 'mult' | 'xmult' | 'special'>('all');
  const filteredJokers = filterType === 'all' ? jokers : jokers.filter(j => j.effectType === filterType);
  const selected = jokers.find(j => j.id === selectedJoker);
  return <div className="space-y-6" data-id="element-179">
      {/* Intro */}
      <div className="panel p-5" style={{
      background: 'rgba(180,79,255,0.05)',
      border: '1px solid rgba(180,79,255,0.3)'
    }} data-id="element-180">
        <h3 className="text-lg font-bold mb-3" style={{
        color: '#b44fff',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-181">
          🃏 什么是小丑牌？
        </h3>
        <p className="text-sm mb-3" style={{
        color: '#c0a0e0'
      }} data-id="element-182">
          小丑牌是游戏的核心！它们是特殊的增益卡，可以大幅提升你的得分。每局游戏你最多可以持有{' '}
          <span style={{
          color: '#FFD700'
        }} data-id="element-183">
            5张
          </span>{' '}
          小丑牌。
        </p>
        <div className="grid md:grid-cols-3 gap-3 text-sm" data-id="element-184">
          <div className="p-3 rounded-lg" style={{
          background: 'rgba(79,195,247,0.1)',
          border: '1px solid rgba(79,195,247,0.2)'
        }} data-id="element-185">
            <div className="font-bold mb-1" style={{
            color: '#4fc3f7'
          }} data-id="element-186">
              +筹码型
            </div>
            <p style={{
            color: '#b090d0',
            fontSize: 12
          }} data-id="element-187">
              增加筹码值，让总筹码更高
            </p>
          </div>
          <div className="p-3 rounded-lg" style={{
          background: 'rgba(255,68,68,0.1)',
          border: '1px solid rgba(255,68,68,0.2)'
        }} data-id="element-188">
            <div className="font-bold mb-1" style={{
            color: '#ff6666'
          }} data-id="element-189">
              +倍率型
            </div>
            <p style={{
            color: '#b090d0',
            fontSize: 12
          }} data-id="element-190">
              增加倍率，让最终得分更高
            </p>
          </div>
          <div className="p-3 rounded-lg" style={{
          background: 'rgba(255,140,0,0.1)',
          border: '1px solid rgba(255,140,0,0.2)'
        }} data-id="element-191">
            <div className="font-bold mb-1" style={{
            color: '#ff8c00'
          }} data-id="element-192">
              ×倍率型
            </div>
            <p style={{
            color: '#b090d0',
            fontSize: 12
          }} data-id="element-193">
              乘法提升倍率，最为强力！
            </p>
          </div>
        </div>
      </div>

      {/* Joker slot visualization */}
      <div data-id="element-194">
        <h4 className="text-sm font-bold mb-3" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-195">
          小丑牌槽位（最多5张）
        </h4>
        <div className="flex gap-3 flex-wrap" data-id="element-196">
          {[{
          emoji: '🃏',
          name: '小丑',
          effect: '+4 Mult'
        }, {
          emoji: '😄',
          name: '快乐小丑',
          effect: '+8 Mult'
        }, {
          emoji: '💰',
          name: '贪婪小丑',
          effect: '+3 Mult/♦'
        }, {
          emoji: '📋',
          name: '蓝图',
          effect: '复制效果'
        }, {
          emoji: '➕',
          name: '空槽位',
          effect: ''
        }].map((slot, i) => <div key={i} className="joker-card p-3 rounded-xl text-center flex-1 min-w-24" style={{
          border: slot.emoji === '➕' ? '2px dashed rgba(180,79,255,0.3)' : undefined,
          opacity: slot.emoji === '➕' ? 0.5 : 1
        }} data-id="element-197">
              <div className="text-3xl mb-1" data-id="element-198">{slot.emoji}</div>
              <div className="text-xs font-bold" style={{
            color: '#d0b0ff',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-199">
                {slot.name}
              </div>
              {slot.effect && <div className="text-xs mt-1 number-mono" style={{
            color: '#ff6666'
          }} data-id="element-200">
                  {slot.effect}
                </div>}
            </div>)}
        </div>
      </div>

      {/* Filter */}
      <div className="flex gap-2 flex-wrap" data-id="element-201">
        {(['all', 'chips', 'mult', 'xmult', 'special'] as const).map(type => <button key={type} onClick={() => setFilterType(type)} className={`nav-tab ${filterType === type ? 'active' : ''}`} style={filterType === type && type !== 'all' ? {
        color: effectTypeConfig[type as keyof typeof effectTypeConfig]?.color,
        borderColor: effectTypeConfig[type as keyof typeof effectTypeConfig]?.color,
        background: effectTypeConfig[type as keyof typeof effectTypeConfig]?.bg
      } : undefined} data-id="element-202">
            {type === 'all' ? '全部' : type === 'chips' ? '+筹码型' : type === 'mult' ? '+倍率型' : type === 'xmult' ? '×倍率型' : '特殊型'}
          </button>)}
      </div>

      {/* Joker grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-id="element-203">
        {filteredJokers.map(joker => {
        const rarity = rarityConfig[joker.rarity];
        const effectType = effectTypeConfig[joker.effectType];
        const isSelected = selectedJoker === joker.id;
        return <button key={joker.id} onClick={() => setSelectedJoker(isSelected ? null : joker.id)} className="joker-card p-3 rounded-xl text-left transition-all duration-200" style={{
          border: isSelected ? `2px solid ${rarity.color}` : undefined,
          boxShadow: isSelected ? `0 0 20px ${rarity.bg}` : undefined,
          transform: isSelected ? 'scale(1.02)' : undefined
        }} data-id="element-204">
              <div className="text-2xl mb-2" data-id="element-205">{joker.emoji}</div>
              <div className="text-xs font-bold mb-1" style={{
            color: rarity.color,
            fontFamily: 'Cinzel, serif'
          }} data-id="element-206">
                {joker.name}
              </div>
              <div className="text-xs px-1.5 py-0.5 rounded inline-block mb-2 number-mono" style={{
            background: effectType.bg,
            color: effectType.color,
            border: `1px solid ${effectType.color}40`
          }} data-id="element-207">
                {joker.effect}
              </div>
              <div className="text-xs" style={{
            color: '#7060a0'
          }} data-id="element-208">
                {rarity.label}
              </div>
            </button>;
      })}
      </div>

      {/* Selected joker detail */}
      {selected && <div className="panel p-5 animate-score-pop" style={{
      border: `1px solid ${rarityConfig[selected.rarity].border}`,
      boxShadow: `0 0 20px ${rarityConfig[selected.rarity].bg}`
    }} data-id="element-209">
          <div className="flex items-start gap-4" data-id="element-210">
            <div className="joker-card p-4 rounded-xl text-center flex-shrink-0" style={{
          minWidth: 80
        }} data-id="element-211">
              <div className="text-4xl mb-1" data-id="element-212">{selected.emoji}</div>
              <div className="text-xs" style={{
            color: rarityConfig[selected.rarity].color
          }} data-id="element-213">
                {rarityConfig[selected.rarity].label}
              </div>
            </div>
            <div className="flex-1" data-id="element-214">
              <h4 className="font-bold text-lg mb-1" style={{
            color: '#FFD700',
            fontFamily: 'Cinzel, serif'
          }} data-id="element-215">
                {selected.name}
              </h4>
              <div className="inline-block px-2 py-1 rounded text-sm number-mono mb-3" style={{
            background: effectTypeConfig[selected.effectType].bg,
            color: effectTypeConfig[selected.effectType].color,
            border: `1px solid ${effectTypeConfig[selected.effectType].color}40`
          }} data-id="element-216">
                {selected.effect}
              </div>
              <p className="text-sm mb-3" style={{
            color: '#c0a0e0'
          }} data-id="element-217">
                {selected.description}
              </p>
              <div className="p-3 rounded-lg text-xs" style={{
            background: 'rgba(255,215,0,0.05)',
            border: '1px solid rgba(255,215,0,0.2)',
            color: '#c0a060'
          }} data-id="element-218">
                💡 示例：{selected.example}
              </div>
            </div>
          </div>
        </div>}

      {/* Scoring order */}
      <div className="section-divider" data-id="element-219" />
      <div data-id="element-220">
        <h4 className="text-sm font-bold mb-3" style={{
        color: '#FFD700',
        fontFamily: 'Cinzel, serif'
      }} data-id="element-221">
          📐 小丑牌的计分顺序
        </h4>
        <p className="text-sm mb-4" style={{
        color: '#b090d0'
      }} data-id="element-222">
          小丑牌的效果按照从左到右的顺序依次触发，顺序非常重要！
        </p>
        <div className="flex items-center gap-2 flex-wrap p-4 panel" data-id="element-223">
          <div className="text-center" data-id="element-224">
            <div className="chip-badge px-3 py-2 rounded-lg text-sm number-mono" data-id="element-225">
              30 筹码
            </div>
            <div className="text-xs mt-1" style={{
            color: '#9080b0'
          }} data-id="element-226">
              初始
            </div>
          </div>
          <span style={{
          color: '#7060a0'
        }} data-id="element-227">
            ×
          </span>
          <div className="text-center" data-id="element-228">
            <div className="mult-badge px-3 py-2 rounded-lg text-sm number-mono" data-id="element-229">
              2 倍率
            </div>
            <div className="text-xs mt-1" style={{
            color: '#9080b0'
          }} data-id="element-230">
              初始
            </div>
          </div>
          <span style={{
          color: '#7060a0'
        }} data-id="element-231">
            →
          </span>
          <div className="text-center" data-id="element-232">
            <div className="mult-badge px-3 py-2 rounded-lg text-sm number-mono" data-id="element-233">
              +4
            </div>
            <div className="text-xs mt-1" style={{
            color: '#9080b0'
          }} data-id="element-234">
              小丑1
            </div>
          </div>
          <span style={{
          color: '#7060a0'
        }} data-id="element-235">
            →
          </span>
          <div className="text-center" data-id="element-236">
            <div className="mult-badge px-3 py-2 rounded-lg text-sm number-mono" data-id="element-237">
              ×1.5
            </div>
            <div className="text-xs mt-1" style={{
            color: '#ff8c00'
          }} data-id="element-238">
              小丑2
            </div>
          </div>
          <span style={{
          color: '#7060a0'
        }} data-id="element-239">
            →
          </span>
          <div className="text-center" data-id="element-240">
            <div className="score-badge px-3 py-2 rounded-lg text-sm number-mono" data-id="element-241">
              270
            </div>
            <div className="text-xs mt-1" style={{
            color: '#9080b0'
          }} data-id="element-242">
              最终
            </div>
          </div>
        </div>
        <p className="text-xs mt-2" style={{
        color: '#7060a0'
      }} data-id="element-243">
          30 × (2+4) × 1.5 = 30 × 6 × 1.5 = 270分
        </p>
      </div>
    </div>;
}